import { Component, ViewChild } from "@angular/core";
import { BannersComponent } from "./banners/banners.component";
import { DisclaimersComponent } from "./disclaimers/disclaimers.component";
import { LinksComponent } from "./links/links.component";

@Component({
  selector: "app-addons",
  templateUrl: "./addons.component.html",
  styleUrls: ["./addons.component.scss"],
  standalone: false,
})
export class AddonsComponent {
  @ViewChild(BannersComponent) bannersComponent?: BannersComponent;
  @ViewChild(DisclaimersComponent) disclaimersComponent?: DisclaimersComponent;
  @ViewChild(LinksComponent) linksComponent?: LinksComponent;

  selectedTabIndex = 0;

  onTabChange(index: number): void {
    this.selectedTabIndex = index;
  }

  get addLabelKey(): string {
    switch (this.selectedTabIndex) {
      case 1:
        return "addons.disclaimers.add";
      case 2:
        return "addons.links.add";
      default:
        return "addons.banners.add";
    }
  }

  addItem(): void {
    switch (this.selectedTabIndex) {
      case 1:
        this.disclaimersComponent?.showAddForm();
        break;
      case 2:
        this.linksComponent?.showAddForm();
        break;
      default:
        this.bannersComponent?.showAddForm();
        break;
    }
  }
}
